import { render, staticRenderFns } from "./upload-queue-dialog.vue?vue&type=template&id=26c4c7a8&"
import script from "./upload-queue-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-queue-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports